'use client'

import { useRenewStore } from '@/features/studio-renew/store'
import { ApiError } from '@/features/veluvit/services/api'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

/** 응답·Operation 콜백을 계정이 바뀐 화면에 적용하지 않도록 요청 시작 때 고정한다. */
export function studioSession() {
  const { identity, data } = useSessionStore.getState()
  const owner = useRenewStore.getState().owner
  if (!owner || data?.user?.id !== owner || data.user.guest)
    throw new ApiError(
      '로그인한 작가 계정을 확인해 주세요.',
      403,
      'STUDIO_SESSION_REQUIRED'
    )
  return {
    owner,
    assertCurrent() {
      const session = useSessionStore.getState()
      if (
        session.identity !== identity ||
        session.data?.user?.id !== owner ||
        session.data.user.guest ||
        useRenewStore.getState().owner !== owner
      ) {
        throw new ApiError(
          '계정이 바뀌어 이전 작업 연결을 중단했어요.',
          0,
          'SESSION_CHANGED'
        )
      }
    },
  }
}
